module.exports = __webpack_public_path__ + "resources/img/solution_game_kr_m.273f02e96cd976ae10b0162801ab1ecd.jpg";